import { render, staticRenderFns } from "./SettingsTechnicalWork.vue?vue&type=template&id=f848b5fc&scoped=true&"
import script from "./SettingsTechnicalWork.vue?vue&type=script&lang=js&"
export * from "./SettingsTechnicalWork.vue?vue&type=script&lang=js&"
import style0 from "./SettingsTechnicalWork.vue?vue&type=style&index=0&id=f848b5fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f848b5fc",
  null
  
)

export default component.exports